export default function runNetworkSpeedTest() {
    let promise = new Promise(function (resolve, reject) {
      try {
        // If the internet is really slow to continue.
        // throw(new Error("Internet is too slow to continue, please try again later or contact your school's IT department."))
        // when implementing this feature, make sure to test async check end works with handlePreCheckItemFinished
        setTimeout(() => resolve("done"), 100);
      } catch (err) {
        reject(err);
      }
    });
    return promise;
  }
  